/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';

import DesktopAccountWalletInfo from './DesktopAccountWalletInfo';
import configENV from '../../../../config';

const { PERSIST_KEY } = configENV;

class DesktopAccountPaymentMethod extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { billingAddress, wallet, fetchBillingAddress } = this.props;
        fetchBillingAddress(billingAddress, wallet);
    };

    render() {
        const {
            wallet,
            cardtypes,
            billingAddress,
            countries,
        } = this.props;
        const {
            handleClickAddNewCreditCard,
            handleClickEditCreditCard,
            handleClickRemoveCreditCard,
            handleSetDefaultCard,
        } = this.props;

        return (
            <>
                <>
                    <DesktopAccountWalletInfo
                        cardtypes={cardtypes}
                        wallet={wallet}
                        billingAddress={billingAddress}
                        countries={countries}
                        onAddCard={handleClickAddNewCreditCard}
                        onEditCard={handleClickEditCreditCard}
                        onRemoveCard={handleClickRemoveCreditCard}
                        onSetDefaultCard={handleSetDefaultCard}
                    />
                </>
            </>
        );
    }
}

DesktopAccountPaymentMethod.defaultProps = {
    billingAddress: [],
    wallet: [],
    cardtypes: [],
    countries: [],
};

DesktopAccountPaymentMethod.propTypes = {
    billingAddress: PropTypes.array,
    countries: PropTypes.array,
    wallet: PropTypes.array,
    cardtypes: PropTypes.array,
    fetchBillingAddress: PropTypes.func.isRequired,
    handleClickAddNewCreditCard: PropTypes.func.isRequired,
    handleClickEditCreditCard: PropTypes.func.isRequired,
    handleClickRemoveCreditCard: PropTypes.func.isRequired,
    handleSetDefaultCard: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        billingAddress: newState.billingAddress,
        wallet: newState.wallet,
        countries: newState.countries,
        cardtypes: newState.cardtypes,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchBillingAddress: (billingAddress, wallet) => dispatch(EventDispatcher.fetchBillingAddress(billingAddress, wallet)),
    handleClickAddNewCreditCard: () => dispatch(EventDispatcher.handleClickAddNewCreditCard('desktop')),
    handleClickRemoveCreditCard: (walletId) => dispatch(EventDispatcher.handleClickRemoveCreditCard(walletId)),
    handleClickEditCreditCard: (walletAndBillingInfo, template) => dispatch(EventDispatcher.handleClickEditCreditCard(walletAndBillingInfo, template)),
    handleSetDefaultCard: (walletId) => dispatch(EventDispatcher.handleSetDefaultCard(walletId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DesktopAccountPaymentMethod));
